import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { SideDetailViewService } from '@y42/core/container-with-side-detail-view';
import { JobUIModel } from '../../../state';

@UntilDestroy()
@Component({
  selector: 'y42-job-list-view-details',
  templateUrl: './job-list-view-details.component.html',
  styleUrls: ['./job-list-view-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListViewDetailsComponent implements OnInit {
  constructor(private readonly sideDetailViewService: SideDetailViewService<void, JobUIModel['request_id']>) {}

  private readonly title = 'Job Details';

  state = connectState(this, {
    jobId: this.sideDetailViewService.data$,
  });

  ngOnInit() {
    this.sideDetailViewService.setSideDetailViewTitle(this.title);
  }
}
